/**
 * OP-3605 — os ícones do menu do BD Interno.
 *
 * SVG de traço escrito à mão, sem biblioteca: são dezenove ícones e nenhum
 * outro lugar do app pede um conjunto, então uma dependência nova custaria
 * mais do que resolve.
 *
 * Todos herdam `currentColor`, então ficam brancos sozinhos quando o item
 * está ativo — não existe variante clara e variante escura para manter.
 */
import { FC, ReactElement } from 'react'
import { IconeMenu } from './menu'

const TRACOS: Record<IconeMenu, ReactElement> = {
  // 5897 — Previsões
  carteira: (
    <>
      <path d="M3 3v18h18" />
      <path d="m7 15 4-4 3 3 5-6" />
      <path d="M19 8v3" strokeDasharray="1 2" />
    </>
  ),
  lotes: (
    <>
      <path d="M3 8a2 2 0 0 0 2-2h14a2 2 0 0 0 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 0-2 2H5a2 2 0 0 0-2-2v-2a2 2 0 0 0 0-4z" />
      <path d="M13 6v2" />
      <path d="M13 11v2" />
      <path d="M13 16v2" />
    </>
  ),
  gmv: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M15 9.5c-.5-1-1.6-1.5-3-1.5-1.7 0-3 .9-3 2s1.3 1.7 3 2 3 .9 3 2-1.3 2-3 2c-1.4 0-2.5-.5-3-1.5" />
      <path d="M12 6v2" />
      <path d="M12 16v2" />
    </>
  ),
  simulador: (
    <>
      <path d="M4 21v-7" />
      <path d="M4 10V3" />
      <path d="M12 21v-9" />
      <path d="M12 8V3" />
      <path d="M20 21v-5" />
      <path d="M20 12V3" />
      <path d="M1 14h6" />
      <path d="M9 8h6" />
      <path d="M17 16h6" />
    </>
  ),
  estudo: (
    <>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      <path d="M9 13V9" />
      <path d="M12 13V7" />
      <path d="M15 13v-2" />
    </>
  ),
  qualidade: (
    <>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1" />
    </>
  ),
  ordem: (
    <>
      <rect x="8" y="2" width="8" height="4" rx="1" />
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <path d="M8 12h8" />
      <path d="M8 16h5" />
    </>
  ),
  importacao: (
    <>
      <path d="M12 3v11" />
      <path d="m7.5 9.5 4.5 4.5 4.5-4.5" />
      <path d="M4 20h16" />
    </>
  ),
  tecnicos: (
    <>
      <path d="M15 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="8.5" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </>
  ),
  analytics: (
    <>
      <path d="M3 3v18h18" />
      <path d="M8 17v-5" />
      <path d="M13 17V8" />
      <path d="M18 17v-9" />
    </>
  ),
  config: (
    <>
      <path d="M4 6h16" />
      <path d="M4 12h16" />
      <path d="M4 18h16" />
      <circle cx="9" cy="6" r="2" />
      <circle cx="15" cy="12" r="2" />
      <circle cx="8" cy="18" r="2" />
    </>
  ),
  hoje: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18" />
      <path d="M8 3v4" />
      <path d="M16 3v4" />
      <circle cx="12" cy="15.5" r="1.5" />
    </>
  ),
  fila: (
    <>
      <path d="M3 13h4.5l1.8 2.7h5.4L16.5 13H21" />
      <path d="M5.6 5h12.8l2.6 8v4.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V13z" />
    </>
  ),
  remessas: (
    <>
      <path d="M3 6h11v10H3z" />
      <path d="M14 9.5h3.8l3.2 3.5V16h-7z" />
      <circle cx="7.5" cy="18" r="2" />
      <circle cx="17.5" cy="18" r="2" />
    </>
  ),
  contratos: (
    <>
      <path d="M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7z" />
      <path d="M14 2v5h5" />
      <path d="m9 15 2 2 4-4" />
    </>
  ),
  historico: (
    <>
      <path d="M3.2 12a8.8 8.8 0 1 0 2.9-6.5L3 8" />
      <path d="M3 3.5V8h4.5" />
      <path d="M12 8v4.2l2.8 1.8" />
    </>
  ),
  minhas: (
    <>
      <path d="M21.5 2.5 11 13" />
      <path d="m21.5 2.5-6.8 19-3.7-8.5L2.5 9.3z" />
    </>
  ),
  posicao: (
    <>
      <path d="m12 2.5 8.5 4.6v9.8L12 21.5 3.5 16.9V7.1z" />
      <path d="m3.5 7.1 8.5 4.6 8.5-4.6" />
      <path d="M12 11.7v9.8" />
    </>
  ),
  equipamentos: (
    <>
      <rect x="5" y="5" width="14" height="14" rx="2" />
      <rect x="9.5" y="9.5" width="5" height="5" />
      <path d="M9 2v3" />
      <path d="M15 2v3" />
      <path d="M9 19v3" />
      <path d="M15 19v3" />
      <path d="M2 9h3" />
      <path d="M2 15h3" />
      <path d="M19 9h3" />
      <path d="M19 15h3" />
    </>
  ),
  razao: (
    <>
      <path d="M12 7.5v13" />
      <path d="M3 18.5a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
    </>
  ),
  catalogo: (
    <>
      <rect x="3" y="3" width="7.5" height="7.5" rx="1.5" />
      <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5" />
      <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5" />
      <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5" />
    </>
  ),
  entrada: (
    <>
      <path d="M12 2.5v10" />
      <path d="m8 9 4 4 4-4" />
      <path d="M4 14.5V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4.5" />
    </>
  ),
  transferencias: (
    <>
      <path d="M4 8h16" />
      <path d="m17 5 3 3-3 3" />
      <path d="M20 16H4" />
      <path d="m7 13-3 3 3 3" />
    </>
  ),
  baixas: (
    <>
      <rect x="2.5" y="4" width="19" height="5" rx="1.5" />
      <path d="M4.5 9v9a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V9" />
      <path d="M9.5 14h5" />
    </>
  ),
  inventario: (
    <>
      <rect x="8" y="2" width="8" height="4" rx="1" />
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <path d="m9 14 2 2 4-4" />
    </>
  ),
  ocorrencias: (
    <>
      <path d="M10.3 3.9 2.2 17.6a2 2 0 0 0 1.7 3h16.2a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
      <path d="M12 9.5v4" />
      <path d="M12 17h.01" />
    </>
  ),
  notificacoes: (
    <>
      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
      <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    </>
  ),
  mais: (
    <>
      <circle cx="5" cy="12" r="1.4" />
      <circle cx="12" cy="12" r="1.4" />
      <circle cx="19" cy="12" r="1.4" />
    </>
  ),
}

export const IconeDoMenu: FC<{ nome: IconeMenu; tamanho?: number }> = ({ nome, tamanho = 18 }) => (
  <svg
    viewBox="0 0 24 24"
    width={tamanho}
    height={tamanho}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    style={{ flexShrink: 0 }}
  >
    {TRACOS[nome]}
  </svg>
)

/** A seta do cabeçalho de grupo; o giro fica no styled-component. */
export const SetaDoGrupo: FC = () => (
  <svg
    viewBox="0 0 24 24"
    width={14}
    height={14}
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m6 9 6 6 6-6" />
  </svg>
)
